import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(organization_id) {
    return RequesterV1.get(
      "organization/partners/producers/list_producers/" + organization_id
    );
  },
  fetchProducersFormalizedActive(organization_id) {
    return RequesterV1.get(
      "organization/partners/producers/fetch_producers/" + organization_id + "/formalized_active"
    );
  },
  fetchProducersNotFormalizedActive(organization_id) {
    return RequesterV1.get(
      "organization/partners/producers/fetch_producers/" + organization_id + "/not_formalized_active"
    );
  },
  fetchProducersInactive(organization_id) {
    return RequesterV1.get(
      "organization/partners/producers/fetch_producers/" + organization_id + "/inactive"
    );
  },
  downloadRepProducersXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_producers_xlsx`,
      { responseType: "blob" }
    );
  },
  downloadRepProducersFormalizedActiveXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_producers_formalized_active_xlsx`,
      { responseType: "blob" }
    );
  },
  downloadRepProducersNotFormalizedActiveXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_producers_not_formalized_active_xlsx`,
      { responseType: "blob" }
    );
  },
  downloadRepProducersInactiveXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_producers_inactive_xlsx`,
      { responseType: "blob" }
    );
  },
  downloadRepCropFieldsXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_crop_fields_xlsx`,
      { responseType: "blob" }
    );
  },
  downloadRepCropFieldsFormalizedActiveXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_crop_fields_formalized_active_xlsx`,
      { responseType: "blob" }
    );
  }
  ,
  downloadRepCropFieldsNotFormalizedActiveXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_crop_fields_not_formalized_active_xlsx`,
      { responseType: "blob" }
    );
  },
  downloadRepCropFieldsInactiveXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/list_producers/${organization_id}/download_rep_crop_fields_inactive_xlsx`,
      { responseType: "blob" }
    );
  }
};
